import { FireIcon, FreezeIcon, Button } from '@razz-team/ui-web';
import { useCardFreezeMutation, useCardUnfreezeMutation } from '../../../api/cards';
import { ApiCard } from '../../../openapi';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export function isFreezable(card: ApiCard) {
  return card.status === 'ACTIVE' || card.status === 'FROZEN';
}

export function CardFreezeButton({ card }: { card: ApiCard }) {
  const { t } = useTranslation();
  const freezeCardMutation = useCardFreezeMutation(card.id);
  const unfreezeCardMutation = useCardUnfreezeMutation(card.id);
  const isFrozen = card.status === 'FROZEN';
  const mutation = isFrozen ? unfreezeCardMutation : freezeCardMutation;

  const handleClick = useCallback(() => mutation.mutate(), [mutation]);

  return (
    <Button
      color="secondary"
      startIcon={isFrozen ? <FireIcon /> : <FreezeIcon />}
      loading={mutation.isPending}
      onClick={handleClick}
    >
      {isFrozen ? t('Unfreeze') : t('Freeze')}
    </Button>
  );
}
